import React, { Component } from 'react'

class Preload extends Component {
    render() {
        if(true===this.props.show){
            return (
                <div className="preload-wrapper">
                    <div id="preloader_4">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            )
        } else {
            return ''
        }
    }
}

export default Preload